var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLkDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "41.27mm",
    height: "41.27mm",
    viewBox: "0 0 116.99 116.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #005c8e;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M68.99,20.99v4h27v12h-9v59h-46.5c-5.79,0-10.5-4.71-10.5-10.5v-48.5h-9v-12h27v-4h21M71.99,17.99h-27v4h-27v18h9v45.5c0,7.46,6.04,13.5,13.5,13.5h49.5v-59h9v-18h-27v-4h0ZM43.49,39.99v44h-3v-44h3M46.49,36.99h-9v50h9v-50h0ZM59.99,39.99v44h-3v-44h3M62.99,36.99h-9v50h9v-50h0ZM76.49,39.99v44h-3v-44h3M79.49,36.99h-9v50h9v-50h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLkDelete);
export default __webpack_public_path__ + "static/media/LK_Delete.9b3bf13bf262fa376f7dd77e36c3a3c0.svg";
export { ForwardRef as ReactComponent };